import axis from "./axisDes.js"
import grid from "./gridDes.js"
import legend from "./legendDes.js"
import tooltip from "./tooltipDes.js"
import baseChartOpt from "./baseChartOptDes.js"
import { publicComponentOption } from "dependencies/base"
const primaryChartOpt = { axis, grid, legend, tooltip }
const baseOpt = { ...publicComponentOption }
delete baseOpt.pluginName
//返回el-select能用的一个用来描述配置项中英文名对应关系的数组
export const getChartOptionDes = opt => {
  const res = []
  //baseChartOpt是每个图表都有的的图表用的非echarts配置项
  res.push(...toSelectOpt("", baseOpt))
  res.push(...toSelectOpt("", baseChartOpt))
  for (const name in primaryChartOpt) {
    if (Object.hasOwnProperty.call(primaryChartOpt, name)) {
      const element = primaryChartOpt[name]
      const chartOpt = opt.chartOption
      if (chartOpt.hasOwnProperty(name)) {
        res.push(...toSelectOpt("chartOption." + name, element))
      } else if (name === "axis") {
        if (chartOpt.hasOwnProperty("yAxis")) {
          res.push(...toSelectOpt("chartOption.yAxis", element, "x轴"))
        } else if (chartOpt.hasOwnProperty("xAxis")) {
          res.push(...toSelectOpt("chartOption.xAxis", element, "y轴"))
        }
      }
    }
  }
  return res
}
function toSelectOpt(preKey, des, baseName) {
  const res = []
  for (const k in des) {
    if (Object.hasOwnProperty.call(des, k)) {
      const item = des[k]
      res.push({
        label: baseName ? baseName + item : item,
        value: preKey + k
      })
    }
  }
  return res
}
